import { baseApi } from "./baseApi";

const LOCAL_TRANSPORT_RULE_BASE_URL = "/local-transport-rule";

export const localTransportRuleApi = baseApi.injectEndpoints({
  tagTypes: ["LocalTransportRule"],
  endpoints: (build) => ({
    // CREATE
    addLocalTransportRule: build.mutation({
      query: (body) => ({
        url: LOCAL_TRANSPORT_RULE_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "LocalTransportRule", id: "LIST" }],
    }),

    toggleBidirectionalRule: build.mutation({
      query: (id) => ({
        url: `${LOCAL_TRANSPORT_RULE_BASE_URL}/${id}/toggle-bidirectional`,
        method: "PATCH",
      }),
      invalidatesTags: (result, error, id) => [
        { type: "LocalTransportRule", id },
        { type: "LocalTransportRule", id: "LIST" },
      ],
    }),

    // LIST
    listLocalTransportRule: build.query({
      query: (params) => ({
        url: LOCAL_TRANSPORT_RULE_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ _id }) => ({
                type: "LocalTransportRule",
                id: _id,
              })),
              { type: "LocalTransportRule", id: "LIST" },
            ]
          : [{ type: "LocalTransportRule", id: "LIST" }],
    }),

    // DETAIL
    getLocalTransportRuleDetail: build.query({
      query: (id) => `${LOCAL_TRANSPORT_RULE_BASE_URL}/${id}`,
      providesTags: (result, error, { _id }) => [
        { type: "LocalTransportRule", id: _id },
        { type: "LocalTransportRule", id: "LIST" },
      ],
    }),

    // UPDATE
    updateLocalTransportRule: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${LOCAL_TRANSPORT_RULE_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "LocalTransportRule", id },
        { type: "LocalTransportRule", id: "LIST" },
      ],
    }),

    // DELETE
    deleteLocalTransportRule: build.mutation({
      query: (id) => ({
        url: `${LOCAL_TRANSPORT_RULE_BASE_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "LocalTransportRule", id: "LIST" }],
    }),

    // DDL
    getDDLRuleList: build.query({
      query: (params) => ({
        url: `${LOCAL_TRANSPORT_RULE_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({
                type: "LocalTransportRule",
                _id,
              })),
              { type: "LocalTransportRule", id: "DDL" },
            ]
          : [{ type: "LocalTransportRule", id: "DDL" }],
    }),
    checkTransportRules: build.query({
      query: (params) => ({
        url: `${LOCAL_TRANSPORT_RULE_BASE_URL}/check-rules`,
        params: {
          branch: params?.branch?._id || params?.branch,
          // Only include toBranch if it actually exists
          ...(params?.toBranch?._id || params?.toBranch
            ? { toBranch: params.toBranch._id || params.toBranch }
            : {}),
          transportationMode: params?.transportationMode,
          distanceKm: params?.distanceKm,
        },
      }),
      keepUnusedDataFor: 0,
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddLocalTransportRuleMutation,
  useToggleBidirectionalRuleMutation,
  useListLocalTransportRuleQuery,
  useLazyListLocalTransportRuleQuery,
  useGetLocalTransportRuleDetailQuery,
  useUpdateLocalTransportRuleMutation,
  useDeleteLocalTransportRuleMutation,
  useLazyGetDDLRuleListQuery,
  useGetDDLRuleListQuery,
  useCheckTransportRulesQuery,
  useLazyCheckTransportRulesQuery,
} = localTransportRuleApi;
